module.exports = __webpack_public_path__ + "static/media/ro.ce48887a.svg";